// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
 APIUrl: 'https://svindustriesapi.itsmysv.in/api/',
//APIUrl: 'http://127.0.0.1:8000/api/',

  notification: {
    // API endpoint for sending notifications
    apiEndpoint: '/notifications',

    enabled: true,
    methods: {
      email: true,
      whatsapp: true,
      both: true
    },

    defaultMethod: 'both',

    // Retry settings
    retryAttempts: 3,
    retryDelay: 1000, // milliseconds

    // Timeout for notification requests
    requestTimeout: 10000 // milliseconds
  }
};
